import { isUint8Array, uint8ArrayToHexString } from "./uint8array";
import { keccak256 } from "ethereum-cryptography/keccak.js";
import { utf8ToBytes } from "ethereum-cryptography/utils.js";
import { isHexStrict } from "./string";
export var isAddress = function (value, checkChecksum) {
    if (checkChecksum === void 0) { checkChecksum = true; }
    if (typeof value !== "string" && !isUint8Array(value)) {
        return false;
    }
    var valueToCheck;
    if (isUint8Array(value)) {
        valueToCheck = uint8ArrayToHexString(value);
    }
    else if (typeof value === "string" && !isHexStrict(value)) {
        valueToCheck = value.toLowerCase().startsWith("0x") ? value : "0x".concat(value);
    }
    else {
        valueToCheck = value;
    }
    // check if it has the basic requirements of an address
    if (!/^(0x)?[0-9a-f]{40}$/i.test(valueToCheck)) {
        return false;
    }
    // If it's ALL lowercase or ALL upppercase
    if (/^(0x|0X)?[0-9a-f]{40}$/.test(valueToCheck) ||
        /^(0x|0X)?[0-9A-F]{40}$/.test(valueToCheck)) {
        return true;
        // Otherwise check each case
    }
    return checkChecksum ? checkAddressCheckSum(valueToCheck) : true;
};
export var checkAddressCheckSum = function (data) {
    if (!/^(0x)?[0-9a-f]{40}$/i.test(data))
        return false;
    var address = data.slice(2);
    var updatedData = utf8ToBytes(address.toLowerCase());
    var addressHash = uint8ArrayToHexString(keccak256(ensureIfUint8Array(updatedData))).slice(2);
    for (var i = 0; i < 40; i += 1) {
        // the nth letter should be uppercase if the nth digit of casemap is 1
        if ((parseInt(addressHash[i], 16) > 7 &&
            address[i].toUpperCase() !== address[i]) ||
            (parseInt(addressHash[i], 16) <= 7 &&
                address[i].toLowerCase() !== address[i])) {
            return false;
        }
    }
    return true;
};
export function ensureIfUint8Array(data) {
    var _a;
    if (!(data instanceof Uint8Array) &&
        ((_a = data === null || data === void 0 ? void 0 : data.constructor) === null || _a === void 0 ? void 0 : _a.name) ===
            "Uint8Array") {
        return Uint8Array.from(data);
    }
    return data;
}
//# sourceMappingURL=address.js.map